import { render } from "./PartResult.vue?vue&type=template&id=bdb6d7e2&scoped=true&bindings={}"
import script from "./PartResult.vue?vue&type=script&lang=ts"
export * from "./PartResult.vue?vue&type=script&lang=ts"

import "./PartResult.vue?vue&type=style&index=0&id=bdb6d7e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bdb6d7e2"

export default script